import request from '@/utils/request'

// 所有专家
export function getExpert(data) {
	return request({
		url:'/app-api/biz/home/get-expertPage',
		method: 'get',
		params: data
	})
}
// 所有专家类型
export function getTypes(data) {
	return request({
		url:'/app-api/biz/home/get-system-type',
		method: 'get',
		params: data
	})
}
// 专家详情
export function getDetail(data) {
	return request({
		url:'/app-api/biz/home/get-expert',
		method: 'get',
		params: data
	})
}
// 收藏专家
export function getUserCollect(id) {
	return request({
		url:'/app-api/biz/my/create-user-collect?id='+id,
		method: 'post',
	})
}
// 取消收藏专家、
export function getDeleteCollect(data) {
	return request({
		url:'/app-api/biz/my/delete-collect-expert',
		method: 'DELETE',
        params: data
	})
}
// 获得我的专家分页--已解锁专家
export function getMyExpert(data) {
	return request({
		url:'/app-api/biz/my/get-my-expertPage',
		method: 'get',
		params: data
	})
}
// 获得用户会员解锁数量
export function getUserNum(data) {
	return request({
		url:'/app-api/biz/my/get-user-lock-count',
		method: 'get',
		params: data
	})
}
// 用户解锁专家
export function getUnlock(id) {
	return request({
		url:'/app-api/biz/my/user-unlock-expert?id='+id,
		method: 'post',
	})
}